import React from "react";
import { getValue } from "@utils/lodash";
import InputField from "@_common/InputRuleFeild";
import { useNavigate } from "react-router-dom";
import FilterSearchDropdown from "@_common/FilterSearchDropdown";
import SearchableDropdownSelect from "@_common/SearchableDropdown";

const ModuleFilter = (props: any) => {
  const navigate = useNavigate();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const {
    handleChangeSelect,
    countryList,
    states,
    categoryOfLawList,
    legislationList,
    ruleList,
    request,
    additionalFilter,
    smartFilterList,
    selectedSmartFilterIds,
    handleChangeSelectMulti,

    //loading...
    categoryLawLoading,
    legislationLoading,
    legislationRuleLoading,
    resetInput,

    //entity mapping
    headerList,
    headerLoading,
    levelObj,
    childEntityLoading,
    handleClickEntity,
    urlParams,
    handleChangeEntity,
    handleChangeSelectByValue,

    hideUserFilter,
  } = props;
  return (
    <>
      <section className="d-flex align-items-center justify-content-between module-filter-wrapper">
        <div className="d-flex align-items-center">
          {props.filter && (
            <div className="d-flex justify-content-between gap">
              <div className="grid">
                <div className="input-grid-item mt-0 module_filter_fields_wrapper">
                  <label htmlFor="country_id" className="floating-label">
                    Status
                  </label>
                  {/* <InputField
                    inputType="INPUT_REACT_SELECT_MODAL"
                    placeholder="Choose Status"
                    className="form-control w-100"
                    name="country_id"
                    id="country_id"
                    options={props.filterList}
                    value={
                      getValue(props, `filterList.length`, 0) > 0 &&
                      getValue(props, `filterList`, []).filter(
                        (item: object) =>
                          getValue(item, `value`, "") ===
                          getValue(params, `is_configured`, "")
                      )
                    }
                    onChange={(e: any) =>
                      props.handleChangeStatus(
                        "is_configured",
                        getValue(e, `value`, "")
                      )
                    }
                    label="Country"
                    isClear
                    customClass="module_filter_dropdown_wrapper"
                  /> */}
                  <SearchableDropdownSelect
                    placeholder={"Choose Status"}
                    options={props.filterList}
                    searchLoading={props.EvaluatorLoading}
                    handleChange={(e: any) =>
                      props.handleChangeStatus(
                        "is_configured",
                        getValue(e, `value`, ""),
                      )
                    }
                    handleClick={(e: any) =>
                      props.handleChangeStatus(
                        "is_configured",
                        getValue(e, `value`, ""),
                      )
                    }
                    value={
                      getValue(props, `filterList.length`, 0) > 0 &&
                      getValue(props, `filterList`, []).find(
                        (item: object) =>
                          getValue(item, `value`, "") ===
                          getValue(params, `is_configured`, ""),
                      )
                    }
                    className="form-control"
                    name="compliance_status"
                    label="label"
                    id="id"
                    resetInput={resetInput}
                  />
                </div>
              </div>
            </div>
          )}
          {/* &nbsp;&nbsp;&nbsp; */}
          {props.statusFilter && (
            <div className="d-flex justify-content-between gap">
              <div className="grid">
                <div className="input-grid-item mt-0 module_filter_fields_wrapper">
                  <label htmlFor="country_id" className="floating-label">
                    Status
                  </label>
                  {/* <InputField
                    inputType="INPUT_REACT_SELECT_MODAL"
                    placeholder="Choose Status "
                    className="form-control w-100"
                    name="country_id"
                    id="country_id"
                    options={props.filterList}
                    value={
                      getValue(props, `filterList.length`, 0) > 0 &&
                      getValue(props, `filterList`, []).filter(
                        (item: object) =>
                          getValue(item, `value`, "") ===
                          getValue(params, `status`, "")
                      )
                    }
                    onChange={(e: any) =>
                      props.handleChangeStatus(
                        "status",
                        getValue(e, `value`, "")
                      )
                    }
                    label="Country"
                    isClear
                  /> */}
                  <SearchableDropdownSelect
                    placeholder={"Choose Status"}
                    options={props.filterList}
                    searchLoading={props.EvaluatorLoading}
                    handleChange={(e: any) =>
                      props.handleChangeStatus(
                        "status",
                        getValue(e, `value`, ""),
                      )
                    }
                    handleClick={(e: any) =>
                      props.handleChangeStatus(
                        "status",
                        getValue(e, `value`, ""),
                      )
                    }
                    value={
                      getValue(props, `filterList.length`, 0) > 0 &&
                      getValue(props, `filterList`, []).find(
                        (item: object) =>
                          getValue(item, `value`, "") ===
                          getValue(params, `status`, ""),
                      )
                    }
                    className="form-control"
                    name="status"
                    label="label"
                    id="id"
                    resetInput={resetInput}
                  />
                </div>
              </div>
            </div>
          )}
          {/* &nbsp;&nbsp;&nbsp; */}
          {props.filterLocation && (
            <div className="d-flex justify-content-between gap">
              <div className="grid mt-0 module_filter_fields_wrapper">
                <label htmlFor="id" className="floating-label">
                  Location
                </label>
                <FilterSearchDropdown
                  placeholder={"Search Location"}
                  options={props.locationList}
                  searchLoading={props.searchLoading}
                  handleChange={(val: any) => props.handleTriggerLocation(val)}
                  handleClick={(e: any) =>
                    props.handleChangeStatus(
                      "location_id",
                      getValue(e, `id`, ""),
                    )
                  }
                  value={
                    getValue(props, `locationList.length`, 0) > 0 &&
                    getValue(props, `locationList`, []).filter(
                      (item: object) =>
                        getValue(item, `id`, "") ===
                        getValue(params, `location_id`, ""),
                    )[0]
                  }
                  label="label"
                  id="id"
                  name="Location"
                />
              </div>
            </div>
          )}
          {props.filterFrequency && (
            <div className="grid">
              <div className="input-grid-item mt-0 module_filter_fields_wrapper">
                <label htmlFor="id" className="floating-label">
                  Frequency
                </label>
                <FilterSearchDropdown
                  placeholder={"Search Frequency"}
                  options={props.frequencyList}
                  searchLoading={props.searchFrequencyLoading}
                  handleChange={(val: any) => props.handleTriggerFrequency(val)}
                  handleClick={(e: any) =>
                    props.handleChangeStatus(
                      "frequency_id",
                      getValue(e, `id`, ""),
                    )
                  }
                  value={
                    getValue(props, `frequencyList.length`, 0) > 0 &&
                    getValue(props, `frequencyList`, []).filter(
                      (item: object) =>
                        getValue(item, `id`, "") ==
                        getValue(params, `frequency_id`, ""),
                    )[0]
                  }
                  label="label"
                  id="id"
                  name="Frequency"
                />
              </div>
            </div>
          )}
          {props.filterConfigure && (
            <div className="grid">
              <div className="input-grid-item mt-0 module_filter_fields_wrapper">
                <label htmlFor="is_configured" className="floating-label">
                  Configuration Type
                </label>
                {/* <InputField
                  inputType="INPUT_REACT_SELECT_MODAL"
                  placeholder="Choose Configuration Type"
                  className="form-control w-100"
                  name="is_configured"
                  id="is_configured"
                  options={props.configureStatus}
                  value={
                    getValue(props, `configureStatus.length`, 0) > 0 &&
                    getValue(props, `configureStatus`, []).filter(
                      (item: object) =>
                        getValue(item, `value`, "") ==
                        getValue(params, `is_configured`, "")
                    )
                  }
                  onChange={(e: any) =>
                    props.handleChangeStatus(
                      "is_configured",
                      getValue(e, `value`, "")
                    )
                  }
                  label="Country"
                  isClear
                  customClass="module_filter_dropdown_wrapper"
                /> */}

                <SearchableDropdownSelect
                  placeholder={"Choose Configuration Type"}
                  options={props.configureStatus}
                  searchLoading={props.EvaluatorLoading}
                  handleChange={(e: any) =>
                    props.handleChangeStatus(
                      "is_configured",
                      getValue(e, `value`, ""),
                    )
                  }
                  handleClick={(e: any) =>
                    props.handleChangeStatus(
                      "is_configured",
                      getValue(e, `value`, ""),
                    )
                  }
                  value={
                    getValue(props, `configureStatus.length`, 0) > 0 &&
                    getValue(props, `configureStatus`, []).find(
                      (item: object) =>
                        getValue(item, `value`, "") ==
                        getValue(params, `is_configured`, ""),
                    )
                  }
                  className="form-control"
                  name="is_configured"
                  label="label"
                  id="id"
                  resetInput={resetInput}
                />
              </div>
            </div>
          )}
          {/* &nbsp;&nbsp;&nbsp; */}
          {props.activeStatus && (
            <div className="grid">
              <div className="input-grid-item mt-0 module_filter_fields_wrapper">
                <label htmlFor="is_configured" className="floating-label">
                  Activation Status
                </label>
                {/* <InputField
                  inputType="INPUT_REACT_SELECT_MODAL"
                  placeholder="Choose Activation Status"
                  className="form-control w-100"
                  name="activation_status"
                  id="activation_status"
                  options={props.activationStatus}
                  value={
                    getValue(props, `activationStatus.length`, 0) > 0 &&
                    getValue(props, `activationStatus`, []).filter(
                      (item: object) =>
                        getValue(item, `value`, "") ==
                        getValue(params, `activation_status`, "")
                    )
                  }
                  onChange={(e: any) =>
                    props.handleChangeStatus(
                      "activation_status",
                      getValue(e, `value`, "")
                    )
                  }
                  label="Country"
                  isClear
                  customClass="module_filter_dropdown_wrapper"
                /> */}

                <SearchableDropdownSelect
                  placeholder={"Choose Activation Status"}
                  options={props.activationStatus}
                  searchLoading={props.EvaluatorLoading}
                  handleChange={(e: any) =>
                    props.handleChangeStatus(
                      "activation_status",
                      getValue(e, `value`, ""),
                    )
                  }
                  handleClick={(e: any) =>
                    props.handleChangeStatus(
                      "activation_status",
                      getValue(e, `value`, ""),
                    )
                  }
                  value={
                    getValue(props, `activationStatus.length`, 0) > 0 &&
                    getValue(props, `activationStatus`, []).find(
                      (item: object) =>
                        getValue(item, `value`, "") ==
                        getValue(params, `activation_status`, ""),
                    )
                  }
                  className="form-control"
                  name="activation_status"
                  label="label"
                  id="id"
                  resetInput={resetInput}
                />
              </div>
            </div>
          )}
          {/* &nbsp;&nbsp;&nbsp; */}
          {props.filterCompliance && (
            <div className="select-grid">
              <div className="input-grid-item mt-0 module_filter_fields_wrapper">
                <label htmlFor="is_configured" className="floating-label">
                  Compliance Type
                </label>
                {/* <InputField
                  // inputType="INPUT_REACT_SELECT_MODAL"
                  inputType="INPUT_REACT_SELECT"
                  placeholder="Choose Compliance Type"
                  className="form-control w-100"
                  name="compliance_type_id"
                  id="compliance_type_id"
                  options={props.peComplianceList}
                  value={
                    getValue(props, `peComplianceList.length`, 0) > 0 &&
                    getValue(props, `peComplianceList`, []).filter(
                      (item: object) =>
                        getValue(item, `id`, "") ==
                        getValue(params, `compliance_type_id`, "")
                    )
                  }
                  onChange={(e: any) =>
                    props.handleChangeStatus(
                      "compliance_type_id",
                      getValue(e, `id`, "")
                    )
                  }
                  label="Country"
                  isClear
                  customClass="module_filter_dropdown_wrapper"
                /> */}

                <SearchableDropdownSelect
                  placeholder={"Choose Compliance Type"}
                  options={props.peComplianceList}
                  searchLoading={props.EvaluatorLoading}
                  handleChange={(e: any) =>
                    props.handleChangeStatus(
                      "compliance_type_id",
                      getValue(e, `id`, ""),
                    )
                  }
                  handleClick={(e: any) =>
                    props.handleChangeStatus(
                      "compliance_type_id",
                      getValue(e, `id`, ""),
                    )
                  }
                  value={
                    getValue(props, `peComplianceList.length`, 0) > 0 &&
                    getValue(props, `peComplianceList`, []).find(
                      (item: object) =>
                        getValue(item, `id`, "") ==
                        getValue(params, `compliance_type_id`, ""),
                    )
                  }
                  className="form-control"
                  name="compliance_type_id"
                  label="label"
                  id="id"
                  resetInput={resetInput}
                />
              </div>
            </div>
          )}
          {/* &nbsp;&nbsp;&nbsp; */}
          {props.filterComplianceStatus && (
            <div className="select-grid">
              <div className="input-grid-item mt-0 module_filter_fields_wrapper">
                <label htmlFor="is_configured" className="floating-label">
                  Compliance Status
                </label>
                {/* <InputField
                  // inputType="INPUT_REACT_SELECT_MODAL"
                  inputType="INPUT_REACT_SELECT"
                  placeholder="Choose Compliance Status"
                  className="form-control w-100"
                  name="compliance_status"
                  id="compliance_status"
                  options={props.complianceStatusOptions}
                  value={getValue(props, `compliance_status_ID[${0}]`, "")}
                  onChange={(e: any) =>
                    props.handleChangeStatus(
                      "compliance_status",
                      getValue(e, `value`, "")
                    )
                  }
                  label="Country"
                  isClear
                  customClass="module_filter_dropdown_wrapper"
                /> */}

                <SearchableDropdownSelect
                  placeholder={"Choose Compliance Status"}
                  options={props.complianceStatusOptions}
                  searchLoading={props.EvaluatorLoading}
                  handleChange={(e: any) =>
                    props.handleChangeStatus(
                      "compliance_status",
                      getValue(e, `value`, ""),
                    )
                  }
                  handleClick={(e: any) =>
                    props.handleChangeStatus(
                      "compliance_status",
                      getValue(e, `value`, ""),
                    )
                  }
                  value={
                    getValue(props, `compliance_status_ID.length`, 0) > 0 &&
                    getValue(props, `compliance_status_ID`, []).find(
                      (item: object) =>
                        getValue(item, `val`, "") ==
                        getValue(params, `compliance_status_ID`, ""),
                    )
                  }
                  className="form-control"
                  name="compliance_status"
                  label="label"
                  id="id"
                  resetInput={resetInput}
                />
              </div>
            </div>
          )}

          {props.filterStatus && (
            <div className="select-grid">
              <div className="input-grid-item mt-0 module_filter_fields_wrapper">
                <label htmlFor="is_configured" className="floating-label">
                  Status
                </label>
                {/* <InputField
                    // inputType="INPUT_REACT_SELECT_MODAL"
                    inputType="INPUT_REACT_SELECT"
                    placeholder="Choose Compliance Status"
                    className="form-control w-100"
                    name="compliance_status"
                    id="compliance_status"
                    options={props.complianceStatusOptions}
                    value={getValue(props, `compliance_status_ID[${0}]`, "")}
                    onChange={(e: any) =>
                      props.handleChangeStatus(
                        "compliance_status",
                        getValue(e, `value`, "")
                      )
                    }
                    label="Country"
                    isClear
                    customClass="module_filter_dropdown_wrapper"
                  /> */}

                <SearchableDropdownSelect
                  placeholder={"Choose Status"}
                  options={props.statusOptions}
                  searchLoading={props.EvaluatorLoading}
                  handleChange={(e: any) =>
                    props.handleChangeStatus("status", getValue(e, `value`, ""))
                  }
                  handleClick={(e: any) =>
                    props.handleChangeStatus("status", getValue(e, `value`, ""))
                  }
                  value={
                    getValue(props, `status_ID.length`, 0) > 0 &&
                    getValue(props, `status_ID`, []).find(
                      (item: object) =>
                        getValue(item, `val`, "") ==
                        getValue(params, `status_ID`, ""),
                    )
                  }
                  className="form-control"
                  name="status"
                  label="label"
                  id="id"
                  resetInput={resetInput}
                />
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ModuleFilter;
